import Dashboard2 from "../../core/Dashboard2"


const PropertyOwnerDashboard = () => {
  return (
    <>
      <Dashboard2/>
    </>
  )
}

export default PropertyOwnerDashboard